/**
 * sensors data event javascript
 */

/*********************** events start ***********************/

// 注册登录事件
$('.header__action-item--account').click(function () {
    // 注册结果
    $('.form_register_btn').click(function () {
        localStorage.setItem('sensors_is_register', 1);
        localStorage.setItem('sensors_is_login', 1);
    });
    $('#register-form-error').on('DOMNodeInserted', function () {
        sensors.track('RegisterResult', {
            register_email: $('#create_customer input[name="customer[email]"]').val(),
            is_success: false,
            fail_reason: $(this).text()
        });
        localStorage.removeItem('sensors_is_register');
        localStorage.removeItem('sensors_is_login');
    });
    // 登录结果
    $('#header_customer_login .form_login_btn').click(function () {
        localStorage.setItem('sensors_is_login', 1);
    });
});

if (window.location.pathname.includes("/login")) {
    if ($("#login-form-error").text().length>0) {
        sensors.track('LoginResult', {
            login_email: $('#create_customer input[name="customer[email]"]').val(),
            is_success: false,
            fail_reason: $("#login-form-error").text()
        });
        localStorage.removeItem('sensors_is_register');
        localStorage.removeItem('sensors_is_login');
    }
    $("button[type='submit'].form__submit").click(()=>{
        localStorage.setItem('sensors_is_login', 1);
    })
}
// 判断登录是否成功,暂时无法判断

// if (window.location.pathname=="/account") {
//     sensorHandleLogin(log)
// }



// 订阅结果
$('#footer-newsletter button[type="submit"]').click(function () {
    let subscribEmail = $('#footer-newsletter input[name="contact[email]"]').val();
    if (subscribEmail != '' && subscribEmail.indexOf('@') > 0) {
        sensors.track('SubscribResult', {
            subscribe_email: subscribEmail
        });
    }
});


// 取消加购 - minicart
$('#mini-cart').on('click', 'a.mini-cart__quantity-remove', function () {
    sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), $('#mini-cart input.quantity-selector__value').val())
});
$('#mini-cart').on('change', 'input.quantity-selector__value', function () {
    let adjustQty = $(this).data('current-value') - $(this).val();
    if (adjustQty > 0) {
        sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), adjustQty)
    }else{
        let $this = $(this).parents(".mini-cart__line-item")
        let refererCookie = getRefererPageCookie($this.attr("data-productid"))
        trackWithProductInfo("AddToCart",{
            ...refererCookie,
            sku_id:$this.attr('data-sku_id'),
            sku_name:$this.find('.mini-cart__product-title').html(),
            sku_price:$this.find('.money').html().replace(/\$|,|£/g, '') * 1,
            commodity_tag:$this.attr('data-commodity_tag'),
            sku_quantity:Math.abs(adjustQty)
        })
    }
});
$('#mini-cart').on('click', 'button.quantity-selector__button', function () {
    if ($(this).index() == 0) {
        sensorHandleRemoveFromCart($(this).parents('.mini-cart__line-item'), 1)
    }else{
        let $this = $(this).parents(".mini-cart__line-item")
        let refererCookie = getRefererPageCookie($this.attr("data-productid"))
        trackWithProductInfo("AddToCart",{
            ...refererCookie,
            sku_id:$this.attr('data-sku_id'),
            sku_name:$this.find('.mini-cart__product-title').html(),
            sku_price:$this.find('.money').html().replace(/\$|,|£/g, '') * 1,
            commodity_tag:$this.attr('data-commodity_tag'),
            sku_quantity: 1
        })
    }
});


// 取消加购 - cart页面
$('#shopify-section-cart-template').on('click', 'a.line-item__quantity-remove', function () {
    sensorHandleRemoveFromCart($(this).parents('tr.line-item'), $('#shopify-section-cart-template input.quantity-selector__value').val())
});
$('#shopify-section-cart-template').on('change', 'input.quantity-selector__value', function () {
    let adjustQty = $(this).data('current-value') - $(this).val();
    if (adjustQty > 0) {
        sensorHandleRemoveFromCart($(this).parents('tr.line-item'), adjustQty)
    }else{
        let $this = $(this).parents(".line-item--stack")
        let refererCookie = getRefererPageCookie($this.attr("data-productid"))
        trackWithProductInfo("AddToCart",{
            ...refererCookie,
            sku_id:$this.attr('data-sku_id'),
            sku_name:$this.find('.line-item__title').html(),
            sku_price:$this.find('.money').html().replace(/\$|,|£/g, '') * 1,
            commodity_tag:$this.attr('data-commodity_tag'),
            sku_quantity:Math.abs(adjustQty)
        })
    }
});
$('#shopify-section-cart-template').on('click', 'button.quantity-selector__button', function () {
    if($(this).index() == 0){
        sensorHandleRemoveFromCart($(this).parents('tr.line-item'), 1)
    }else{
        let $this = $(this).parents(".line-item--stack")
        let refererCookie = getRefererPageCookie($this.attr("data-productid"))
        trackWithProductInfo("AddToCart",{
            ...refererCookie,
            sku_id:$this.attr('data-sku_id'),
            sku_name:$this.find('.line-item__title').html(),
            sku_price:$this.find('.money').html().replace(/\$|,|£/g, '') * 1,
            commodity_tag:$this.attr('data-commodity_tag'),
            sku_quantity: 1
        })
    }
});

function sensorHandleRemoveFromCart(parentObj, quantity) {
    let removeFromCartParams = {
        sku_id: parentObj.data('sku_id'),
        sku_name: parentObj.data('sku_name'),
        sku_price: Number((parentObj.data('sku_price') + '').replace(',', '')),
        commodity_tag: parentObj.data('commodity_tag'),
        sku_quantity: quantity,
    };
    trackWithProductInfo('RemoveFromCart', removeFromCartParams)
    // sensors.track('RemoveFromCart', removeFromCartParams);
}

var mutationObserver = new MutationObserver(()=>{
    $(".search-bar__result-products").on("click","a",(e)=>{
        e.preventDefault()
        let $this = $(e.target).parents(".search-bar__result-item")
        let count=$(".search-bar__result-products>a")
        let SearchResultClick={
            // key_word:$(".search-bar__input.is-filled").val(),
            key_word:$this.find(".search-bar__item-title").text(),
            keyword_type:"商品名推荐搜索词",
            result_number:count.length,
            position_number:count.index($this)+1+'',
            sku_id:$this.attr("data-skuid"),
            sku_name:$this.find(".search-bar__item-title").text(),
            sku_price:$this.find(".money").html().replace(/\$|,|£/g, "") * 1,
            commodity_tag:$this.attr("data-tag"),
            // click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $this.attr("data-skuid")
        }
        RantionSetCookie($this.attr("data-productid"),JSON.stringify({
            referer_page_type:"搜索结果",
            click_id:SearchResultClick.click_id,
            referer_page:window.location.href,
            key_word:SearchResultClick.key_word,
            keyword_type:SearchResultClick.keyword_type,
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $this.attr("data-skuid")
        }))
        // console.log(SearchResultClick);
        trackWithProductInfo('SearchResultClick',SearchResultClick)
        // sensors.track('SearchResultClick',SearchResultClick)
        sensors.track("ReturnSearchResult",{
            key_word:$this.find(".search-bar__item-title").text(),
            keyword_type:"商品名推荐搜索词",
            result_number:count.length,
        })
        window.location.href=$this.attr("href")
    })
});
mutationObserver.observe(document.querySelector('#search-popover>form'), { attributeFilter:["class"]});
function getPageName(){
    var pathname = window.location.pathname
    if('/' === pathname){
        return  '首页'
    }
    if (pathname.includes("/cart")) {
        return  "购物车页"
    }
    if (pathname.includes("/collections")) {
        return "分类页"
    }
    if(pathname.includes('/products')){
        return "商品详情页"
    }
    return "商品详情页"
}
// 导航栏埋点
function navSensors(dom) {
    let href = dom.getAttribute("href")
    RantionSetCookie(href,JSON.stringify({
      referer_page_type:"导航栏",
      referer_page: window.location.href,
      // mkt_page: getPageName(),
      // mkt_area: $(dom).parent().parent().find('.menu-img-text-title').text(),
      // mkt_position_number: $(dom).index() + 1,
      click_id: sensors.quick('getAnonymousID') + new Date().getTime() + href
    }))
}

// 猜你喜欢 跳转商品详情
$('.also_like_item_title').on('click',function (){
    var _this = $(this)
    var refererCookie=getRefererPageCookie(_this.attr("data-productid"))
    if(refererCookie)
    trackWithProductInfo("AddToCart",{
        ...refererCookie,
        sku_id:_this.attr("data-variant"),
        sku_name:_this.parent().find(".also_like_item_title").text().trim(),
        sku_price:_this.data("price") / 100,
        commodity_tag:_this.attr("data-tag"),
        sku_quantity:1
    })
})

// 我猜你喜欢 添加购物车
$('.also-like-btn').on('click',function (){
    var _this = $(this)
    let href = _this.attr("href")
    RantionSetCookie(href,JSON.stringify({
        referer_page_type:"资源位",
        referer_page: window.location.href,
        mkt_page: '购物车',
        mkt_area: 'You May Also Like',
        mkt_position_number: $('.also_like_item_title').index(_this) + 1,
        click_id: sensors.quick('getAnonymousID') + new Date().getTime() + href
    }))
})
if (location.pathname=="/") {
  // 首页轮播图埋点
  // console.log("这里是轮播图");
  $(".custom_banner_main").on("click", "a.slideshow__slide", function (e) {
    // e.preventDefault()
    let idx = $(this)
      .parents(".flickity-slider")
      .find("a.slideshow__slide")
      .index($(this));
    // let idx = $("a.slideshow__slide").index(this)
    sensors.track("mktClick", {
      mkt_page: "首页",
      mkt_area: "top_banner",
      mkt_position_number: idx + 1 + "",
      mkt_material_id: $(this).attr("href"),
      mkt_material_name: document.title,
      sku_price: "",
      commodity_tag: "",
    });
    // window.location.href = $(this).attr("href")
  });

    // 首页资源位点击Category Events
    $(".container .rte[data-index]").on("click",(e)=>{
        let $this = $(e.target).parents(".rte")
        sensors.track("mktClick",{
            mkt_page:"首页",
            mkt_area:"category_events",
            mkt_position_number:$this.attr("data-index"),
            mkt_material_id:$this.find("a").attr("href"),
            mkt_material_name:$this.find(".cus-text-info-title").html().trim(),
            sku_price:"",
            commodity_tag:""
        })
        RantionSetCookie($this.find("a").attr("href"),JSON.stringify({
            mkt_page:"首页",
            mkt_area:"category_events",
            mkt_position_number:$this.attr("data-index"),
            referer_page_type:"资源位",
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + $this.find("a").attr("href"),
            referer_page:window.location.href,
        }))
    })
    // 第二期埋点
    $(".three_video").on("click",".video_product",(e)=>{
        let $this = $(e.target).parents(".video_product")
        let idx = $(".three_video .video_product").index($this) + 1 + ""
        sensors.track("mktClick",{
            mkt_page:"首页",
            mkt_area:"fast_entrance",
            mkt_position_number:idx,
            mkt_material_id:"",
            mkt_material_name:$this.find(".video_product_title").text().trim(),
            sku_price:"",
            commodity_tag:""
        })
    })
    $(".view_more_courses a").click((e)=>{
        sensors.track("mktClick",{
            mkt_page:"首页",
            mkt_area:"fast_entrance",
            mkt_position_number:"4",
            mkt_material_id:$(e.target).attr("href"),
            mkt_material_name:"",
            sku_price:"",
            commodity_tag:""
        })
    })

    // CREATE THE MOMENT资源位点击
    $(".moment_message").on("click",".message_box",(e)=>{
        // e.preventDefault()
        let $this = $(e.target).parents(".message_box")
        let idx = $(".moment_message .message_box").index($this) + 1 + ""
        let mkt = {
            mkt_page:"首页",
            mkt_area:$this.parents(".moment_message").find(".section__header-stack").text().trim(),
            mkt_position_number: idx,
            mkt_material_id:$this.find("a").attr("href"),
            mkt_material_name:$this.find(".user_name").text().trim(),
            sku_price:"",
            commodity_tag:""
        }
        sensors.track("mktClick",mkt)
        RantionSetCookie(mkt.mkt_material_id,JSON.stringify({
            mkt_page:"首页",
            mkt_area:mkt.mkt_area,
            mkt_position_number:mkt.mkt_position_number,
            referer_page_type:"资源位",
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + mkt.mkt_material_id,
            referer_page:window.location.href,
        }))
    })

    // 首页flash deal js
    $("[data-section-type='flash_sale_section']").each((i,dom)=>{
        console.log("1231231",i);
        let $this = $(dom)
        // let flashItem = $("[data-section-type='flash_sale_section'] .product-item")
        let flashItem = $this.find(".product-item")
        let flashCount = flashItem.length
        let flashNum = 0
        if (flashCount>0) {
            flashCount--
        }
        let flashTabsTimes = Math.floor(flashCount/5)
        $this.find(".arrow-l").on("click",()=>{
          flashNum--;
          if (flashNum<0) {
            flashNum = 0
          }
          flashItem.css("transform",`translate(${flashNum * 500}%)`);
          console.log(flashNum);
        })
        $this.find(".arrow-r").on("click",()=>{
          flashNum++;
          if (flashNum>flashTabsTimes) {
            flashNum=flashTabsTimes
          }
          flashItem.css("transform",`translate(-${flashNum * 500}%)`);
        //   console.log(flashNum);
        })
        
    })

    // Hot Sale Categories资源位点击
    $("[data-section-type='collection-list']").on("click","a",function(e){
        let $this = $(this)
        sensors.track("mktClick",{
            mkt_page:"首页",
            mkt_area:"Hot Sale Categories",
            mkt_position_number:$this.attr("data-collection-index")*1+1+'',
            mkt_material_id:$this.attr("href"),
            mkt_material_name:$this.find(".collection-item__title").text().trim(),
            sku_price:"",
            commodity_tag:""
        })
    })

    // top sale 资源位点击,加购埋点
    $("[data-section-type='for_more_products']").on("click",".for_collection_item",function(e){
        // e.preventDefault()
        let $this = $(this)
        let idx=$this.parent().find(".for_collection_item").index($(this))
        let scookie={
        mkt_page: "首页",
        mkt_area: $this.parents("[data-section-type='for_more_products']").find(".section_title").text().trim(),
        mkt_position_number: idx + 1+'',
        mkt_material_id:$this.data("skuid"),
        mkt_material_name: $this.find(".for_vendor_title").text().trim(),
        sku_price:$this.data("price") / 100,
        commodity_tag:$this.data("tag")
        }
        console.log('top sale 资源位点击',$this.data("productid"))
        RantionSetCookie($this.data("productid"),JSON.stringify({
            mkt_page: scookie.mkt_page,
            mkt_area: scookie.mkt_area,
            mkt_position_number: scookie.mkt_position_number,
            referer_page_type: "资源位",
            referer_page: window.location.href,
            click_id: sensors.quick('getAnonymousID') + new Date().getTime() + scookie.mkt_material_id
        }))

        sensors.track("mktClick",scookie)


        if (e.target.nodeName=="IMG"&&(!$(e.target).hasClass("image--fade-in"))) {
            e.stopPropagation()
            let refererCookie=getRefererPageCookie($this.attr("data-productid"))
            trackWithProductInfo("AddToCart",{
                ...refererCookie,
                sku_id:$this.attr("data-skuid"),
                sku_name:$this.find(".product_title a").text().trim(),
                sku_price:$this.data("price") / 100,
                commodity_tag:$this.attr("data-tag"),
                sku_quantity:1
            })
            // return
        }
    })

    // flash sale埋点
    $("[data-section-type='flash_sale_section']").on("click",".product-item",function(e){
        let $this = $(this)
        let idx = $this.parents("[data-section-type='flash_sale_section']").find(".product-item").index($(this))
  
        let scookie={
          mkt_page: "首页",
          mkt_area: $this.parents("[data-section-type='flash_sale_section']").find(".section__title").text().trim(),
          mkt_position_number: idx + 1+'',
          mkt_material_id:$this.attr("data-skuid"),
          mkt_material_name: $this.find('.flash-title').text().trim(),
          sku_price:$this.data('product-price') / 100,
          commodity_tag:$this.data("tag")
        }
        sensors.track("mktClick", {
          ...scookie
        })
        
  
        RantionSetCookie($this.data("productid"),JSON.stringify({
          mkt_page: scookie.mkt_page,
          mkt_area: scookie.mkt_area,
          mkt_position_number: scookie.mkt_position_number,
          referer_page_type: "资源位",
          referer_page: window.location.href,
          click_id: sensors.quick('getAnonymousID') + new Date().getTime() + scookie.mkt_material_id
        }))
  
        if ($(e.target).hasClass('addToCart')) {
        //   e.stopPropagation()
          let refererCookie=getRefererPageCookie($this.attr("data-productid"))
          trackWithProductInfo("AddToCart",{
              ...refererCookie,
              sku_id:scookie.mkt_material_id,
              sku_name:scookie.mkt_material_name,
              sku_price:scookie.sku_price,
              commodity_tag:scookie.commodity_tag,
              sku_quantity:1
          })
      }
    })
}

// 默认设置checkout付款
sessionStorage.setItem("normalCheckout",1)
/*********************** events end ***********************/
